import * as React from "react";
import * as ReactDOM from "react-dom";
import "./tablestyle.scss";
import {
    Grid,
    GridCellProps,
    GridColumn as Column,
    GridDetailRowProps,
    GridExpandChangeEvent,
    GridNoRecords
  } from "@progress/kendo-react-grid";
import { useNavigate } from "react-router-dom";
import { Icon } from '@iconify/react';


interface Props {
    data: any;
    title: string;
    candidate_data: string;
  }


const PendingTimesheet: React.FC<Props> = ({ data, title , candidate_data}) => {

  const navigate = useNavigate()

  return (
    <Grid 
        data={data}
    >
        <GridNoRecords>
          <div className="noData">
            <Icon icon="mdi:smiley-neutral-outline" />
            No data to display
          </div>
        </GridNoRecords>
        <Column field="Duration" title="Duration" cell={(props: GridCellProps) => Duration(props)}/>
        <Column field="projectName" title="Project" />
        <Column cell={(props: GridCellProps) => ViewButton(props , candidate_data)} width="100px" />
  </Grid>
  )
}

export default PendingTimesheet; 

const Duration = (props: GridCellProps) => {
    return <td><div className="dateWrap">{`${new Date(parseInt(props.dataItem.startDate)).toDateString()} - ${new Date(parseInt(props.dataItem.endDate)).toDateString()}`}</div></td>;
  };

  const ViewButton = (props: GridCellProps , candidate_data: any) => {
  
    const navigate = useNavigate()  
    return (
      <td>
        <button type="button" className="link-btn"  
          onClick={(e: any) => navigate('../addTimesheet' , {state :{state: props.dataItem ,   candidate_data: candidate_data}})}>
            {props.dataItem.activeStatus ? 'Edit' : 'Create New'}
        </button>
      </td>
    );
  }